var exports = {
  "k": "x4ddf2309--14211b--container",
};

module.exports = exports;
